import type { DeleteTestResultsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteTestResultsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteTestResults = createMutationHook({
  name: 'deleteTestResults',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.testResult.delete.mutationOptions({ onSuccess }),
  mapInput: (variables: { ids: string[] }) => ({ ids: variables.ids }),
  invalidate: (trpc) => [
    trpc.frontend.testResult.testResultById.queryKey(),
    trpc.frontend.testResult.testResultsByControlId.queryKey(),
    trpc.frontend.testResult.latestTestResultsByControlId.queryKey(),
    trpc.frontend.testResult.testResults.queryKey(),
    // COI-889: the left-nav badge reads this count family.
    trpc.frontend.testResult.testResultCount.queryKey(),
    // COI-471 parity: Apollo twin also evicts `control` and `risk_score`
    // (test results feed control effectiveness / risk scores).
    trpc.frontend.control.pathKey(),
    trpc.frontend.risk.pathKey(),
  ],
  mapResponse: (
    _result,
    variables: { ids: string[] }
  ): DeleteTestResultsMutation => ({
    delete_relation_file: {
      __typename: 'relation_file_mutation_response',
      affected_rows: variables.ids.length,
    },
    delete_test_result: {
      __typename: 'test_result_mutation_response',
      affected_rows: variables.ids.length,
    },
  }),
  graphqlDocument: DeleteTestResultsDocument,
  graphqlVariables: (variables: { ids: string[] }) => ({
    Ids: variables.ids,
  }),
  evictFields: [
    'test_result',
    'test_result_aggregate',
    'control',
    'risk_score',
  ],
});
